import React from 'react'
import { Button, CardContainer, NavBar } from '@welbe/web-design-system'
import {
	Title,
	Description,
	SurveyListContainer,
	CardList,
	ActionContainer,
	TitleContainer,
	SurveyTipContainer,
	Paragraph,
	OrderedList,
	Link,
} from './SurveyList.styles'
import { CardItem } from './CardItem'
import { campaignAnswerSessionsInterface } from 'contexts/Global.types'
import { useSurvey } from '../Survey.hooks'
import { Loading } from 'App/components/Loading/Loading'
import { ErrorInfo } from 'App/components/ErrorInfo/ErrorInfo'
import { FiInfo } from 'react-icons/fi'
import { FeedbackUser } from './FeedbackUser'
import { ExpiredInfo } from 'App/components/ExpiredInfo/ExpiredInfo'

export const SurveyList = (): JSX.Element => {
	const {
		campaigns,
		campaign,
		isCampaignExpired,
		hasGlobalError,
		isGlobalLoading,
		surveyTip,
		hasFormToFill,
		setSurveyTip,
		handlePrevious,
		getStatus,
		handleNext,
	} = useSurvey()

	if (isGlobalLoading) return <Loading />
	if (hasGlobalError) return <ErrorInfo />
	if (isCampaignExpired) return <ExpiredInfo />

	if (!hasFormToFill()) return <FeedbackUser />

	return (
		<SurveyListContainer>
			<NavBar onPrevious={handlePrevious} />
			<TitleContainer>
				<Title>Cuestionario NOM-035</Title>
				<FiInfo onClick={() => setSurveyTip(!surveyTip)} />
			</TitleContainer>
			{surveyTip ? (
				<SurveyTipContainer>
					<Paragraph>
						La NOM-035 promueve un ambiente laboral saludable fomentando equipos
						de trabajo armonizados.
					</Paragraph>
					<Paragraph>
						Nuestro objetivo es establecer los elementos para identificar,
						analizar y prevenir los factores de riesgo psicosocial, así como
						para promover un entorno organizacional favorable en los centros de
						trabajo.
					</Paragraph>
					<Paragraph fontWeight={600}>
						Obligaciones de los trabajadores{' '}
					</Paragraph>
					<OrderedList>
						<li>
							Observar las medidas de prevención y/o de control que dispone esta
							Norma y el patrón.
						</li>
						<li>
							Abstenerse de realizar prácticas contrarias al entorno
							organizacional favorable y actos de violencia laboral.
						</li>
						<li>
							Participar en la identificación de los factores de riesgo
							psicosocial y, en su caso, en la evaluación del entorno
							organizacional.
						</li>
						<li>
							Informar sobre prácticas opuestas al entorno organizacional
							favorable y denunciar actos de violencia laboral.
						</li>
						<li>
							Informar por escrito al patrón haber presenciado o sufrido un
							acontecimiento traumático severo.
						</li>
						<li>
							Participar en los eventos de información que proporcione el
							patrón.
						</li>
						<li>
							Someterse a los exámenes médicos y evaluaciones psicológicas que
							determinan la presente Norma, la institución de seguridad social o
							privada, o el médico o psicólogo o psiquiatra del centro de
							trabajo o de la empresa.
						</li>
					</OrderedList>
					<Paragraph fontWeight={500}>
						Cualquier pregunta en relación a la aplicación de esta norma, puedes
						consultar{' '}
						<Link
							href="https://www.dof.gob.mx/nota_detalle.php?codigo=5541828&fecha=23/10/2018#gsc.tab=0"
							target="_blank"
						>
							aquí
						</Link>{' '}
						o acudir directamente con el equipo de RRHH.
					</Paragraph>
				</SurveyTipContainer>
			) : (
				<div>
					<Description>
						Tu participación es indisplensable para detectar riesgos
						psicosociales dentro de la empresa. Contesta las evaluaciones con la
						mayor honestidad y claridad posible
					</Description>
					<CardList>
						{campaigns.map(
							(item: campaignAnswerSessionsInterface, index: number) => (
								<CardContainer
									key={item.id}
									viewed={Boolean(item.dateCompleted)}
									type="horizontal"
									width="100%"
									height="80px"
								>
									<CardItem
										title={item.questionnaire.name}
										description={item.dateCompleted ?? campaign.dateEnd}
										status={getStatus(index)}
									/>
								</CardContainer>
							),
						)}
					</CardList>
				</div>
			)}
			<ActionContainer>
				<Button
					disabled={surveyTip ? false : !hasFormToFill()}
					onClick={() => {
						surveyTip ? setSurveyTip(false) : handleNext()
					}}
				>
					{surveyTip ? 'Regresar' : 'Continuar'}
				</Button>
			</ActionContainer>
		</SurveyListContainer>
	)
}
